(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loginTips"] && !Shopify.designMode) return;
  try {
    var api_url = 'https://api.tozostore.com/api/v1/';
  // var api_url = 'https://api.tozo.tech/api/v1/'
  console.log(api_url)
  var country_id
  var country_iso_code

  const Next_text = document.getElementById('Next_text');
  const Next_img = document.getElementById('Next_img');
  var NextButton = true;
  var SavaButton = true;



  $(document).ready(function() {

    function form_loding(button, type){
      if(button == 'Next'){
        if(type == 'text'){
          NextButton = true
          Next_text.style.display = 'block'
          Next_img.style.display = 'none'
        }else{
          NextButton = false
          Next_text.style.display = 'none'
          Next_img.style.display = 'block'
        }
      }
    }

    // 用户信息
    function get_userinfo(redirect_url){
      const emailNumber = document.querySelector('#email')
      let data = {
        email: emailNumber.value,
      }
      $.ajax({
        url: api_url + 'bshop/userinfo',
        type: 'post',
        data,
        success: function(res) {
          console.log(res)
          set_login_state_fun(1)
          if(res.code == 0){
            let userinfo = res.data ? JSON.stringify(res.data) : ''
            localStorage.setItem('userinfo', userinfo);
            // 从localStorage中获取
            const storedUserInfo = localStorage.getItem('userinfo');
            // 转为对象（如果存储的不是空字符串）
            const userData = storedUserInfo ? JSON.parse(storedUserInfo) : null;
            window.userData = userData
            if(redirect_url){
              window.location.href = redirect_url; // 同步shopfiy登录态
              // callback()
            }else{
              callback()
            }
            console.log(userData)
          }else{
            error_fun(res, 'error_fun')
          }
          },
        error: function(xhr, status, error) {
          error_fun(error, 'error_fun')
        }
      })
    }

    $('#login-tips-form')[0].addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this)
      const redirect_url = get_params('redirect_url');
      const targetUrl = `https://b2b.tozostore.com/${redirect_url}` || 'https://b2b.tozostore.com/'; // 默认跳转首页
      formData.set('redirect_url', targetUrl)
      
      // 打印参数
      for (var value of formData.values()) {
        console.log(value);
      }
      console.log(NextButton)
      if(!NextButton){ return }
      form_loding('Next', 'img')
      api_err.innerHTML = ''
      $.ajax({
        url: api_url + 'bshop/login',
        type: 'post',
        data:formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(res) {
          console.log(res)
          form_loding('Next', 'text')
          if(res.code == 0){
            get_userinfo(res.data.redirect_url)
            set_login_state_fun(2)
            tips_click_set_fun(2)
          }else{
            error_fun(res, 'error_fun')
          }
        },
        error: function(error) {
          form_loding('Next', 'text')
          error_fun(error, 'error_fun')
          // form.reset();
        }
      })
    })

});
  } catch(e) { console.error(e); }
})();

})();
